export * as ContinueRegister from './ContinueRegister'
export * as ModifyRegister from './ModifyRegister'
export * as CreateAnimal from './CreateAnimal'
export * as DeleteAnimal from './DeleteAnimal'
export * as UpdateAnimal from './UpdateAnimal'
export * as CompleteRegister from './CompleteRegister'
